import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'

import { usePageUrl } from '../../../../../lib/pages'

interface LinkToShipmentProps {
  orderId: string | undefined
}

export const LinkToRelatedOrder: React.VFC<LinkToShipmentProps> = ({ orderId }) => {
  const { navigate } = usePageUrl()
  return (
    <SecondaryButton
      text="See Related Order"
      disabled={!orderId}
      onClick={() => {
        navigate(`/account/orders/${orderId}`)
      }}
    />
  )
}
